angular.module("ainapp")
    .controller("addChequePVMasterController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Add Cheque Payment";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.VDesign = {};
            MainService.VoucherDesignsbyType("Cheque Payment").then(function (response) {
                $scope.VDesign = response.data;
            });

            $scope.PrintSetting = {};
            MainService.PrintSettingsbyType("Cheque Payment").then(function (response) {
                $scope.PrintSetting = response.data;
            });

            $scope.TableDesign = {};
        $scope.ColumnWidth = null;
        MainService.TableDesignsbyVoucher("Cheque Payment").then(function (response) {
           if (response.data != null && response.data != "") {
                $scope.TableDesign = response.data;
                $scope.ColumnWidth = JSON.parse(response.data.ColumnWidth);
            }
        });

            $scope.getExtramasters();


            $scope.loadVoucher = function (data) {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetChequePV(data).then(function (response) {
                    if (response.data) {
                        $scope.UpdateDetails(response.data[0]);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("NetworkError");
                })
            }

            $scope.UpdateDetails = function (data) {

                $scope.CurrentBPV = data;
                $scope.CurrentBPV.Date = new Date($scope.CurrentBPV.Date);
                $scope.CurrentBPV.MaturityDate = new Date($scope.CurrentBPV.MaturityDate);
                $scope.VoucherDocs = data.VoucherDocs;

                angular.forEach(data.ChequePVMasterCosts, function (e) {
                    angular.forEach($scope.CostCenters, function (a) {
                        if (e.CostCenter.ParentId == a.CostCenterId) {
                            a.SelectedCostCenterId = e.CostCenter.Id;
                        }
                    })
                })


                $scope.tempTotalQty = 0;
                $scope.tempUnitPrice = 0;
                $scope.tempGross = 0;
                $scope.tempDiscount = 0;
                $scope.tempVat = 0;

                angular.forEach($scope.CurrentBPV.ChequePVDetails, function (e) {
                    $scope.tempTotalQty = $scope.tempTotalQty + e.Quantity;
                    $scope.tempUnitPrice = $scope.tempUnitPrice + e.UnitPrice;
                    $scope.tempGross = $scope.tempGross + e.Total;
                    $scope.tempDiscount = $scope.tempDiscount + e.Discount;
                    $scope.tempVat = $scope.tempVat + e.TaxValue;


                    var costs = angular.copy($scope.CostCenters);
                    if (e.ChequePVMasterCosts.length > 0) {
                        angular.forEach(e.ChequePVMasterCosts, function (ee) {
                            angular.forEach(costs, function (a) {
                                if (ee.CostCenter.ParentId == a.CostCenterId) {
                                    a.SelectedCostCenterId = ee.CostCenter.Id;
                                }
                            })
                            e.CostCenters = angular.copy(costs);
                        })
                    } else {
                        e.CostCenters = angular.copy($scope.CostCenters);
                    }


                });

                if (data.ChequePVDetails.length <= 5) {

                    var temp2 = 5 - data.ChequePVDetails.length;

                    for (var i = 0; i < temp2; i++) {

                        var ChequePVDetails = {

                            Id: "",
                            AccountId: "",
                            MaturityDate: new Date(),
                            Amount: 0,
                            Description: "",
                            ChequeNo: "",
                            Account: {},
                            CostCenters: angular.copy($scope.CostCenters),



                        }

                        $scope.CurrentBPV.ChequePVDetails.push(ChequePVDetails);
                    }
                }

                console.log($scope.CurrentBPV.VehicleCategoryId);
                if ($scope.CurrentBPV.VehicleCategoryId > 0) {
                    $scope.getVehicles();
                }
            }


            $scope.expand = function () {
                $scope.expandView = !$scope.expandView;
            }


            $scope.Currencies = [];
            MainService.CurrencyInDropdown().then(function (response) {
                $scope.Currencies = response.data;
            })

            $scope.VoucherSet = {};
            MainService.VoucherAccountsbyType('Cheque Payment').then(function (response) {
                $scope.VoucherSet = response.data;
            })

             $scope.tableReorderColumnArray = [];
            $scope.ReArrangeTable = function () {
                $scope.RearrangeReqired = false;
                $scope.tableReorderColumnArray = [];

                if ($scope.ColumnWidth != null) {
                    document.querySelectorAll('#rearrangeTable th[data-key], #rearrangeTable td[data-key]').forEach(cell => {
                        let key = cell.getAttribute('data-key');
                        if ($scope.ColumnWidth[key] !== undefined) {
                            cell.style.width = $scope.ColumnWidth[key] + "px";
                        }
                    });
                } else {
                    toastr.info("Table Width Adjustment Empty, Applying Default Width")
                    document.querySelectorAll('#rearrangeTable th[data-key], #rearrangeTable td[data-key]').forEach(cell => {
                        cell.style.width = "100px";
                    });
                }
            };

            $scope.Init = function () {

                $scope.expandView = false;

                $scope.ViewVal = 0;
                var tdate = new Date();
                var year = tdate.getFullYear();
                var month = tdate.getMonth();
                var day = tdate.getDate();
                var ndate = new Date(year + 1, month, day);

                $scope.print = {
                    IsPrint: false,
                }

                $scope.CurrentBPV = {
                    Id: 0,
                    Date: new Date(),
                    Remarks: "",
                    TotalAmount: 0,
                    AccountId: "",
                    DebitAccountId: "",
                    DebitAccountName: "",
                    DebitAmount: 0,
                    DebitDescription: "",
                    ChequeNo: "",
                    VoucherNumber: "",
                    ChequeDate: "",
                    ChequePVDetails: [],
                    Total: 0,
                    BankAccountId: "",
                    MaturityDate: new Date(),
                    ChequeNo: "",
                }

                for (var i = 0; i < 5; i++) {

                    var ChequePVDetails = {
                        Id: "",
                        AccountId: "",
                        MaturityDate: new Date(),
                        Amount: 0,
                        Description: "",
                        ChequeNo: "",
                        Account: {},
                        Flats: [],
                        CostCenters: angular.copy($scope.CostCenters),
                    }

                    $scope.CurrentBPV.ChequePVDetails.push(ChequePVDetails);
                }


                $scope.ErrorText = "";
                $scope.Load = false;



                $scope.CompanyProfile = {};
                if ($stateParams.VoucherId > 0) {
                    MainService.GetCompanyProfile().then(function (response) {
                        $scope.CompanyProfile = response.data;
                        $scope.CostCenters = {};
                        MainService.CostCentersInVoucher("Cheque Payment").then(function (response) {
                            $scope.CostCenters = response.data;
                            $scope.loadVoucher($stateParams.VoucherId);
                        });
                    })
                } else {
                    $scope.CompanyProfile = {};
                    MainService.GetCompanyProfile().then(function (response) {
                        $scope.CompanyProfile = response.data;
                        $scope.CurrentBPV.BaseCurrencyId = $scope.CompanyProfile.BaseCurrencyId;


                        MainService.VoucherAccountsInVoucher("Cheque Payment").then(function (res) {
                            $scope.CurrentBPV.Account = res.data.CreditAccount;
                            $scope.CurrentBPV.AccountId = res.data.CreditAccountId;
                            $scope.CurrentBPV.BankAccount = res.data.BankAccount;
                            $scope.CurrentBPV.BankAccountId = res.data.BankAccountId;
                        }, function (err) {
                            toastr.error("Network Error While Loading Account Settings");
                        })

                        $scope.CostCenters = {};
                        MainService.CostCentersInVoucher("Cheque Payment").then(function (response) {
                            $scope.CostCenters = response.data;
                            angular.forEach($scope.CurrentBPV.ChequePVDetails, function (e) {
                                e.CostCenters = angular.copy($scope.CostCenters);
                            })
                        });

                        if ($scope.CompanyProfile.IsPaymentSingleSerialNo) {
                            MainService.GetNextPaymentVoucherNo().then(function (response) {
                                $scope.CurrentBPV.VoucherNumber = response.data;
                            });
                        } else {
                            MainService.GetNextChequePVMasterNo().then(function (response) {
                                $scope.CurrentBPV.VoucherNumber = response.data;
                            });
                        }

                    })

                }

 setTimeout(function () {
                    $scope.ReArrangeTable();
                }, 2000);

            }
            $scope.Init();

            $scope.PaidFromAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        o.data.LoadType = "Head";
                        o.data.VoucherName = "Cheque Payment";
                        MainService.LoadAccountsInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.NetworkErrorLan);
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 5
            };

            $scope.PaidFromAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentBPV.AccountId = data.Id;
                    $scope.CurrentBPV.Account = {};
                    $scope.CurrentBPV.Account.Name = data.Name;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.PaidFromAutocompleteDataSource
            };

            $scope.BankAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        o.data.LoadType = "Head";
                        o.data.VoucherName = "Cheque Payment";
                        MainService.LoadAccountsInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.NetworkErrorLan);
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 5
            };


            $scope.bankAccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentBPV.BankAccountId = data.Id;
                    $scope.CurrentBPV.BankAccount = {};
                    $scope.CurrentBPV.BankAccount.Name = data.Name;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.BankAutocompleteDataSource
            };

            $scope.AccountAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        o.data.LoadType = "Body";
                        o.data.VoucherName = "Cheque Payment";
                        MainService.LoadAccountsInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.NetworkErrorLan);
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 5
            };

            $scope.AccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.AccountId = data.Id;
                    $scope.SelectedCE.Account = data;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.AccountCodeAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "AccountCode",
                dataTextField: "AccountCode",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.AccountId = data.Id;
                    $scope.SelectedCE.Account = data;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.CarContractcompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "RefNo",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        MainService.CarContractsInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 5
            };

            $scope.CarContractAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "RefNo",
                dataTextField: "RefNo",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.CarContract = {};
                    $scope.SelectedCE.CarContract.RefNo = data.RefNo;
                    $scope.SelectedCE.CarContractId = data.Id;
                    $scope.SelectedCE.VehicleId = data.VehicleId;
                    $scope.SelectedCE.VehicleCategoryId = data.VehicleCategoryId;
                    $scope.$apply();
                    $scope.getVehicles($scope.SelectedCE);
                },
                minLength: 2,
                dataSource: $scope.CarContractcompleteDataSource
            };


           $scope.getBills = function (data) {

                $scope.SelectedCE = data;

                if (data.Account.TypeName == "Creditors" || data.Account.TypeName == "Debtors") {
                    data.UnassignedBillsArray = [];
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.GetPendingBillAnalysis(data.AccountId, "Payment").then(function (response) {
                        if (response.data != null) {
                            if (response.data.length > 0) {
                                data.UnassignedBillsArray = response.data;

                                if (data.Id > 0) {
                                    if (data.UnassignedBillsArrays.length > 0) {
                                        angular.forEach(data.UnassignedBillsArrays, function (e) {
                                            data.UnassignedBillsArray.unshift(e);
                                        })
                                    }
                                }

                                // angular.forEach(data.Bills, function (e) {
                                //     e.Adjustment = 0;
                                //     e.TotalBalance = e.BalanceAmount - e.Adjustment;
                                // })

                                $scope.SelectedCE.AdjustedTotal = 0;
                                $scope.SelectedCE.BalanceAdjusted = data.Amount;
                                $scope.SelectedCE.UnAssignedAdjusted = 0;

                                //$scope.SelectedCE.GrandTotal = data.Amount;

                                angular.forEach(data.UnassignedBillsArray, function (e) {
                                    $scope.SelectedCE.UnAssignedAdjusted = $scope.SelectedCE.UnAssignedAdjusted + e.BalanceAmount;
                                })

                                // $scope.autoAdjust();
                                $('#unassignedModal').modal('show');

                            }
                            else {
                                if (data.Id > 0) {
                                    if (data.UnassignedBillsArrays.length > 0) {

                                        $scope.SelectedCE.UnassignedBillsArray = data.UnassignedBillsArrays;
                                        $scope.SelectedCE.AdjustedTotal = 0;
                                        $scope.SelectedCE.BalanceAdjusted = data.GrandTotal;
                                        $scope.SelectedCE.UnAssignedAdjusted = 0;
                                        angular.forEach(data.UnassignedBillsArray, function (e) {
                                            $scope.SelectedCE.UnAssignedAdjusted = $scope.SelectedCE.UnAssignedAdjusted + e.BalanceAmount;
                                            $scope.SelectedCE.AdjustedTotal = $scope.SelectedCE.AdjustedTotal + e.Adjustment;
                                            $scope.SelectedCE.BalanceAdjusted = $scope.SelectedCE.BalanceAdjusted - e.Adjustment;
                                        })
                                        $('#unassignedModal').modal('show');

                                    } else {
                                        //$scope.SaveWithConfirm();
                                        $('#unassignedModal').modal('show');
                                    }
                                } else {
                                    // $scope.SaveWithConfirm();
                                    $('#unassignedModal').modal('show');
                                }
                            }
                        } else {

                            if (data.Id > 0) {
                                if (data.UnassignedBillsArrays.length > 0) {

                                    $scope.SelectedCE.UnassignedBillsArray = data.UnassignedBillsArrays;

                                    $scope.SelectedCE.AdjustedTotal = 0;
                                    $scope.SelectedCE.BalanceAdjusted = data.GrandTotal;
                                    $scope.SelectedCE.UnAssignedAdjusted = 0;
                                    angular.forEach(data.UnassignedBillsArray, function (e) {
                                        $scope.SelectedCE.UnAssignedAdjusted = $scope.SelectedCE.UnAssignedAdjusted + e.BalanceAmount;
                                        $scope.SelectedCE.AdjustedTotal = $scope.SelectedCE.AdjustedTotal + e.Adjustment;
                                        $scope.SelectedCE.BalanceAdjusted = $scope.SelectedCE.BalanceAdjusted - e.Adjustment;
                                    })
                                    $('#unassignedModal').modal('show');

                                } else {
                                    toastr.warning("Unassigned Bills Not Found !");
                                }
                            } else {
                                toastr.warning("Unassigned Bills Not Found !");
                            }

                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $.LoadingOverlay("hide");
                        toastr.error("Network Error");
                    });

                }

            }


            $scope.matchrow = function (index) {
                $scope.SelectedCE.AdjustedTotal = 0;
                $scope.BalanceAdjusted = 0;
                var row = $scope.SelectedCE.UnassignedBillsArray[index];
                row.Adjustment = 0;
                var tt = $scope.SelectedCE.Amount;
                var assigned = 0;
                angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                    assigned = assigned + e.Adjustment;
                })
                var bal = tt - assigned;
                if (bal > 0 && row.BalanceAmount > bal) {
                    row.Adjustment = bal;
                }
                if (bal > 0 && bal >= row.BalanceAmount) {
                    row.Adjustment = row.BalanceAmount;
                }
                $scope.SelectedCE.AdjustedTotal = assigned + row.Adjustment;
                $scope.SelectedCE.BalanceAdjusted = tt - $scope.SelectedCE.AdjustedTotal;
            }

            $scope.unmatchrow = function (index) {
                $scope.SelectedCE.AdjustedTotal = 0;
                $scope.SelectedCE.BalanceAdjusted = 0;
                var row = $scope.SelectedCE.UnassignedBillsArray[index];
                row.Adjustment = 0;
                var tt = $scope.SelectedCE.Amount;
                var assigned = 0;
                angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                    assigned = assigned + e.Adjustment;
                })
                var bal = tt - assigned;
                $scope.SelectedCE.AdjustedTotal = assigned + row.Adjustment;
                $scope.SelectedCE.BalanceAdjusted = tt - $scope.SelectedCE.AdjustedTotal;
            }

            $scope.autoAdjust = function () {

                $scope.SelectedCE.AdjustedTotal = 0;
                $scope.SelectedCE.BalanceAdjusted = 0;
                var tmp = $scope.SelectedCE.Amount;

                angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                    if (tmp > 0) {
                        if (e.BalanceAmount > tmp) {
                            e.Adjustment = tmp;
                            tmp = 0;
                        } else {
                            e.Adjustment = e.BalanceAmount;
                            tmp = tmp - e.BalanceAmount;
                        }
                        tmp = Math.round(tmp * 100) / 100;
                        //  e.TotalBalance = e.BalanceAmount - e.Adjustment;
                    }
                    $scope.SelectedCE.AdjustedTotal = $scope.SelectedCE.AdjustedTotal + e.Adjustment;
                })
                $scope.SelectedCE.BalanceAdjusted = $scope.SelectedCE.GrandTotal - $scope.SelectedCE.AdjustedTotal;
            }

            $scope.removeAdjustment = function () {
                $scope.SelectedCE.AdjustedTotal = 0;
                $scope.SelectedCE.BalanceAdjusted = 0;
                angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                    e.Adjustment = 0;
                })
                $scope.SelectedCE.BalanceAdjusted = $scope.SelectedCE.GrandTotal - $scope.SelectedCE.AdjustedTotal;
            }

            $scope.validateBill = function () {
                var totaladj = 0;
                angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                    totaladj = totaladj + e.Adjustment;
                })
                if (totaladj > $scope.SelectedCE.Amount) {
                    toastr.warning("Amount exeeding, Values will reset");
                    // angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                    //     e.Adjustment = 0;
                    //     e.TotalBalance = e.BalanceAmount - e.Adjustment;
                    // })
                } else {
                    angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                        e.TotalBalance = e.BalanceAmount - e.Adjustment;
                    })
                }
            }


            $scope.click = function (data, temp) {

                $scope.SelectedCE = data;
                $scope.CurrentBPV.Total = 0;


                angular.forEach($scope.CurrentBPV.ChequePVDetails, function (e) {

                    $scope.CurrentBPV.Total = $scope.CurrentBPV.Total + e.Amount;

                });


                var a = $scope.CurrentBPV.ChequePVDetails.indexOf(data);

                if (($scope.CurrentBPV.ChequePVDetails.length - 1) == a) {
                    var FPVDetails = {
                        Id: "",
                        AccountId: "",
                        MaturityDate: new Date(),
                        Amount: 0,
                        Description: "",
                        ChequeNo: "",

                        Account: {},
                    }

                    $scope.CurrentBPV.ChequePVDetails.push(ChequePVDetails);
                }
            }

            $scope.IsSavePrint = false;

            $scope.SaveVocuher = function (pval) {

                $scope.IsSavePrint = false;
                if (pval == 2) {
                    $scope.IsSavePrint = true;
                }

                $scope.ErrorText = "";

                $scope.CurrentBPV.DateString = $scope.extractDate($scope.CurrentBPV.Date);
                $scope.CurrentBPV.MDateString = $scope.extractDate($scope.CurrentBPV.MaturityDate);
                if ($scope.CurrentBPV.Field16 != null) {
                    $scope.CurrentBPV.F16DateString = $scope.extractDate($scope.CurrentBPV.Field16);
                }
                if ($scope.CurrentBPV.Field17 != null) {
                    $scope.CurrentBPV.F17DateString = $scope.extractDate($scope.CurrentBPV.Field17);
                }
                if ($scope.CurrentBPV.Field18 != null) {
                    $scope.CurrentBPV.F18DateString = $scope.extractDate($scope.CurrentBPV.Field18);
                }
                if ($scope.CurrentBPV.Field19 != null) {
                    $scope.CurrentBPV.F19DateString = $scope.extractDate($scope.CurrentBPV.Field19);
                }
                if ($scope.CurrentBPV.Field20 != null) {
                    $scope.CurrentBPV.F20DateString = $scope.extractDate($scope.CurrentBPV.Field20);
                }

                var count = 0;
                var count2 = 0;
                var costval = 0;
                var count22 = 0;
                angular.forEach($scope.CurrentBPV.ChequePVDetails, function (e) {
                    if ((e.AccountId > 0 && e.Amount <= 0) || (e.AccountId == "" && e.Amount > 0)) {
                        count = count + 1;
                    } else if (e.AccountId > 0 && e.Amount > 0) {
                        count2 = count2 + 1;
                    }
                    if (e.AccountId == "" && e.Amount == 0) {
                        count22 = count22 + 1;
                    }

                    if (e.Field16 != null) {
                        e.F16DateString = $scope.extractDate(e.Field16);
                    }
                    if (e.Field17 != null) {
                        e.F17DateString = $scope.extractDate(e.Field17);
                    }
                    if (e.Field18 != null) {
                        e.F18DateString = $scope.extractDate(e.Field18);
                    }
                    if (e.Field19 != null) {
                        e.F19DateString = $scope.extractDate(e.Field19);
                    }
                    if (e.Field20 != null) {
                        e.F20DateString = $scope.extractDate(e.Field20);
                    }

                    if (e.AccountId > 0 && e.Amount > 0) {
                        e.ChequePVMasterCosts = [];
                        angular.forEach(e.CostCenters, function (a) {
                            if (a.Section == "Body") {
                                if (a.IsMandatory && !a.SelectedCostCenterId > 0) {
                                    $scope.ErrorText = "Cost Center Not Selected For : " + a.CostCenter.Name;
                                } else {
                                    if (a.SelectedCostCenterId > 0) {
                                        var cst = {
                                            CostCenterId: a.SelectedCostCenterId,
                                        }
                                        e.ChequePVMasterCosts.push(cst);
                                        console.log(e);
                                    }
                                }
                            }
                        })
                    }

                    if (e.UnassignedBillsArray != null) {
                        var tot = 0;
                        angular.forEach(e.UnassignedBillsArray, function (bil) {
                            tot = tot + bil.Adjustment;
                        })
                        tot = Math.round(tot * 100) / 100;
                        if (e.Amount < tot) {
                            $scope.ErrorText = "Adjusted Amount Invalid Please Check " + e.Account.Name;
                        }else{
                            e.UnassignedBillsArrays = e.UnassignedBillsArray;
                        }
                    }


                })

                $scope.CurrentBPV.ChequePVMasterCosts = [];
                angular.forEach($scope.CostCenters, function (e) {
                    if (e.Section == "Head") {
                        if (e.IsMandatory && !e.SelectedCostCenterId > 0) {
                            $scope.ErrorText = "Cost Center Not Selected For : " + e.CostCenter.Name;
                        } else {
                            if (e.SelectedCostCenterId > 0) {
                                var cst = {
                                    CostCenterId: e.SelectedCostCenterId,
                                }
                                $scope.CurrentBPV.ChequePVMasterCosts.push(cst);
                            }
                        }
                    }
                })



                if ($scope.CurrentBPV.AccountId == "") {
                    $scope.ErrorText = "Select PDC Payable Account";
                } else if ($scope.CurrentBPV.BankAccountId == "") {
                    $scope.ErrorText = "Select Bank Account";
                } else if (count > 0) {
                    $scope.ErrorText = "Invalid Details";
                } else if (count2 == 0) {
                    $scope.ErrorText = "Invalid Details";
                } else if (count22 == $scope.CurrentBPV.ChequePVDetails.length) {
                    $scope.ErrorText = "Invalid Details";
                }

                if ($scope.VDesign != null) {
                    if ($scope.VoucherDocs.length == 0 && $scope.VDesign.IsAttachmentMandatory) {
                        $scope.ErrorText = "Attachment Missing";
                    }
                }

                if (!$scope.PageAccessInfo.IsAdd && !$scope.CurrentBPV.Id > 0) {
                    toastr.info("You Dont Have Access To Add Data, Please Contact Admin");
                } else if (!$scope.PageAccessInfo.IsEdit && $scope.CurrentBPV.Id > 0) {
                    toastr.info("You Dont Have Access To Edit Data, Please Contact Admin");

                } else {
                    if ($scope.ErrorText == "") {
                        $('#saveModal').modal('show');
                    } else {
                        toastr.warning($scope.ErrorText);
                    }
                }

            }


            $scope.SaveWithConfirm = function () {
                $scope.Load = true;
                $scope.CurrentBPV.VoucherDocs = $scope.VoucherDocs;

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.addChequepvMaster($scope.CurrentBPV).then(function (response) {
                    if (response.data.Message == "Success") {
                        $scope.Load = false;
                        toastr.success("Success");
                        if ($scope.IsSavePrint == true) {
                            toastr.info("Printing");
                            $scope.PrintInvoice(response.data.Id, 'Cheque Payment Voucher', $scope.CurrentBPV.VoucherNumber);
                        }
                        $scope.refreshpageSave();
                        $('#saveModal').modal('hide');
                    } else {
                        $scope.Load = false;
                        toastr.warning(response.data.Message);
                    }
                    $scope.Load = false;

                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("NetworkError");
                    $.LoadingOverlay("hide");
                    $scope.Load = false;
                });
            }

            $scope.refreshpageSave = function () {

                if ($stateParams.VoucherId > 0) {
                    $state.go("ChequePVMaster");
                } else {
                    $scope.Init();
                }

            }



            $scope.ViewVouchers = function () {
                if (!$scope.TokenInfo.IsView && $scope.TokenInfo.Role != 'Admin' && $scope.TokenInfo.Role != 'admin' && $scope.TokenInfo.Role != '0' && $scope.TokenInfo.Role != 'SU') {
                    toastr.info("You Dont Have Access To View Data, Please Contact Admin");
                } else {

                    viewChequePVMasterFactory.select().then(function (_selectedReceipt) {
                        if (_selectedReceipt != null) {
                            loadViewDatas(_selectedReceipt);
                        }
                    })
                }
            }

            var loadViewDatas = function (_selectedReceipt) {
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetChequePV(_selectedReceipt.Id).then(function (response) {

                    $scope.CurrentBPV = response.data[0];
                    $scope.CurrentBPV.Date = new Date($scope.CurrentBPV.Date);

                    $scope.CurrentBPV.MaturityDate = new Date($scope.CurrentBPV.MaturityDate);
                    $scope.CurrentBPV.ChequeDate = new Date($scope.CurrentBPV.ChequeDate);
                    $scope.CurrentBPV.AccountName = $scope.CurrentBPV.Account.Name;
                    $scope.CurrentBPV.BankAccountName = $scope.CurrentBPV.BankAccount.Name;

                    angular.forEach($scope.CurrentBPV.ChequePVDetails, function (e) {
                        if (e.BuildingId > 0) {
                            $scope.getFlats(e);
                        }
                        if (e.VehicleCategoryId > 0) {
                            $scope.getVehicles(e);
                        }
                    })

                    angular.forEach($scope.CurrentBPV.ChequePVDetails, function (e) {

                        e.MaturityDate = new Date(e.MaturityDate);

                    });

                    if ($scope.CurrentBPV.ChequePVDetails.length <= 5) {

                        var temp2 = 5 - $scope.CurrentBPV.ChequePVDetails.length;

                        if (temp2 > 0) {
                            for (var i = 0; i < temp2; i++) {

                                var ChequePVDetails = {
                                    Id: "",
                                    AccountId: "",
                                    MaturityDate: new Date(),
                                    Amount: 0,
                                    Description: "",
                                    ChequeNo: "",
                                    CostCenters: angular.copy($scope.CostCenters),
                                    Account: {},
                                    Flats: [],
                                }


                                $scope.CurrentBPV.ChequePVDetails.push(ChequePVDetails);
                            }
                        }

                    }


                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("NetworkError");
                    $.LoadingOverlay("hide");
                    $scope.Load = false;
                })
            };


            $scope.DeleteVoucher = function () {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {

                    if ($scope.CurrentBPV.Id > 0) {
                        $('#deleteModal').modal('show');
                    }
                }
            }

            $scope.deleteWithConfirm = function () {
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteChequePV($scope.CurrentBPV.Id).then(function (response) {
                    if (response.data.Message == "Success") {
                        toastr.success("Deleted");
                        $('#deleteModal').modal('hide');
                        $state.go("ChequePVMaster");
                    } else {
                        toastr.warning(response.data.Message);
                    }
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                    toastr.error("NetworkError");
                })
            }



            $scope.getFlats = function (row) {
                $scope.Load = true;

                MainService.FlatsByBuildingId(row.BuildingId).then(function (response) {
                    row.Flats = response.data;
                    $scope.Load = false;

                }, function (err) {
                    $scope.Load = false;
                    toastr.error("NetworkError");
                })
            }





            //// for context menu

            $scope.ClickedRow = {};
            $scope.ShowContextMenu = function (data) {
                $scope.ClickedRow = data;
            }

            $scope.InsertRow = function () {

                var ChequePVDetails = {
                    Id: "",
                    AccountId: "",
                    MaturityDate: new Date(),
                    Amount: 0,
                    Description: "",
                    ChequeNo: "",
                    CostCenters: angular.copy($scope.CostCenters),
                    Account: {},
                    Flats: [],
                }

                $scope.CurrentBPV.ChequePVDetails.push(ChequePVDetails);

            }

            $scope.deleteRow = function () {
                var index = $scope.CurrentBPV.ChequePVDetails.indexOf($scope.ClickedRow);
                $scope.CurrentBPV.ChequePVDetails.splice(index, 1);

                $scope.CurrentBPV.Total = 0;


                angular.forEach($scope.CurrentBPV.ChequePVDetails, function (e) {

                    $scope.CurrentBPV.Total = $scope.CurrentBPV.Total + e.Amount;

                });

            }


            $scope.GetBackChequePVMaster = function (type) {
                var temp = 0;
                if ($scope.CurrentBPV.Id > 0) {
                    temp = $scope.CurrentBPV.Id;
                }
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetBackChequePVMaster(temp, type).then(function (response) {
                    if (response.data > 0) {
                        $scope.loadVoucher(response.data)
                    } else {
                        $scope.Init();
                    }
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("NetworkError");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })
            }

            $scope.$on('refreshCostCenterDir', function (e, id) {
                angular.forEach($scope.CostCenters, function (cost) {
                    if (cost.CostCenterId == id) {
                        $.LoadingOverlay("show", {
                            image: "images/load.gif",
                        });
                        MainService.CostCenterSubList(id).then(function (response) {
                            if (response.data != null) {
                                cost.CostCenters = response.data;
                                angular.forEach($scope.CurrentBPV.ChequePVDetails, function (d) {
                                    angular.forEach(d.CostCenters, function (dd) {
                                        if (dd.CostCenterId == id) {
                                            dd.CostCenters = response.data;
                                        }
                                    })
                                })
                            }
                            $.LoadingOverlay("hide");
                        }, function () {
                            toastr.error("Network Error");
                            $.LoadingOverlay("hide");
                        })
                    }
                })
            });


            /////////////////// Attachment //////////////////

            $scope.VoucherDocs = [];
            $scope.initAttachment = function () {
                $scope.VAttachment = {
                    ExpiryDate: null,
                    FileName: "",
                    FilePath: "",
                    Remarks: "",
                    IsActive: true,
                }
            }
            $scope.initAttachment();

            $scope.addAttachmentList = function () {
                if ($scope.VAttachment.FilePath == "") {
                    toastr.warning("Upload File");
                } else if ($scope.VAttachment.FileName == "") {
                    toastr.warning("Enter File Name");
                } else {
                    $scope.VoucherDocs.push($scope.VAttachment);
                    $scope.initAttachment();
                }
            }

            $scope.removeAttachmentRow = function (data) {
                data.IsActive = false;
            }


            // file upload
            $scope.files = [];
            $scope.getFileDetails = function (e) {
                $scope.files = [];
                $scope.$apply(function () {
                    for (var i = 0; i < e.files.length; i++) {
                        $scope.files.push(e.files[i])
                    }
                });
                $scope.Load = true;
                $scope.uploadFiles();
            };
            $scope.remove = function (file) {
                var index = $scope.files.indexOf(file);
                $scope.files.splice(index, 1);
            }
            $scope.uploadFiles = function () {
                var data = new FormData();
                for (var i in $scope.files) {
                    data.append("uploadedFile", $scope.files[i]);
                }
                var objXhr = new XMLHttpRequest();
                objXhr.onreadystatechange = function () {
                    if (objXhr.readyState == XMLHttpRequest.DONE) {
                        if (objXhr.responseText != null && objXhr.responseText != "") {
                            $scope.VAttachment.FilePath = objXhr.responseText;
                            if ($scope.VAttachment.FilePath.includes("error")) {
                                $scope.VAttachment.FilePath = "";
                                toastr.error($scope.LanguageData.UploadError);
                            } else {
                                $scope.VAttachment.FilePath = objXhr.responseText;
                                toastr.success($scope.LanguageData.FileUploaded);
                            }
                        } else {

                        }
                    }
                }
                // objXhr.addEventListener("progress", updateProgress, false);
                objXhr.addEventListener("load", transferComplete, false);
                if ($scope.files.length > 0) {
                    toastr.info($scope.LanguageData.FileUploadingPleaseWait);
                    objXhr.open("POST", config.basePath + "UploadFiles");
                    objXhr.send(data);
                } else {
                    toastr.error($scope.LanguageData.UploadError);
                }
            }
            //function updateProgress(e) {
            //    if (e.lengthComputable) {
            //        document.getElementById('pro').setAttribute('value', e.loaded);
            //        document.getElementById('pro').setAttribute('max', e.total);
            //    }
            //}
            function transferComplete(e) {
                $scope.Load = false;
            }



            $scope.FieldAutoCompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length > 0) {
                            o.data.FieldVoucherName = "Credit Note SR";
                            if (o.data.filter.filters.length == 0) {
                                var temp = {
                                    value: "",
                                    operator: "contains",
                                    field: "Name",
                                    ignoreCase: true
                                }
                                o.data.filter.filters.push(temp);
                            }
                            MainService.FieldAutoComplete(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("Network Error");
                            });
                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.FieldAutoCompleteOptions11 = {
                valuePrimitive: true,
                dataValueField: "Field11",
                dataTextField: "Field11",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentBPV.Field11 = data.Field11;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions12 = {
                valuePrimitive: true,
                dataValueField: "Field12",
                dataTextField: "Field12",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentBPV.Field12 = data.Field12;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions13 = {
                valuePrimitive: true,
                dataValueField: "Field13",
                dataTextField: "Field13",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentBPV.Field13 = data.Field13;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions14 = {
                valuePrimitive: true,
                dataValueField: "Field14",
                dataTextField: "Field14",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentBPV.Field14 = data.Field14;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions15 = {
                valuePrimitive: true,
                dataValueField: "Field15",
                dataTextField: "Field15",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentBPV.Field15 = data.Field15;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };

            $scope.DFieldAutoCompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length > 0) {
                            o.data.FieldVoucherName = "Credit Note SR";
                            if (o.data.filter.filters.length == 0) {
                                var temp = {
                                    value: "",
                                    operator: "contains",
                                    field: "Name",
                                    ignoreCase: true
                                }
                                o.data.filter.filters.push(temp);
                            }
                            MainService.FieldAutoCompleteDetail(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("Network Error");
                            });
                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.D11AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field11",
                dataTextField: "Field11",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field11 = data.Field11;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D12AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field12",
                dataTextField: "Field12",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field12 = data.Field12;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D13AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field13",
                dataTextField: "Field13",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field13 = data.Field13;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D14AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field14",
                dataTextField: "Field14",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field14 = data.Field14;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D15AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field15",
                dataTextField: "Field15",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field15 = data.Field15;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };



        }])
